module.exports = __webpack_public_path__ + "img/bagel_filled.5bbe7a60.jpg";